import { render, staticRenderFns } from "./completeTrip.vue?vue&type=template&id=6fa87b6c&scoped=true&"
import script from "./completeTrip.vue?vue&type=script&lang=js&"
export * from "./completeTrip.vue?vue&type=script&lang=js&"
import style0 from "./completeTrip.vue?vue&type=style&index=0&id=6fa87b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa87b6c",
  null
  
)

export default component.exports